<template>
  <div role="group" class="mb-3">
    <b-form-group :label="question">
      <b-form-tags
        v-model="answer"
        add-on-change
        no-outer-focus
        @input="handleAnswerChange"
      >
        <template
          v-slot="{ tags, disabled, inputAttrs, inputHandlers, removeTag }"
        >
          <ul v-if="tags.length > 0" class="list-inline d-inline-block mb-2">
            <li v-for="tag in tags" :key="tag" class="list-inline-item">
              <b-form-tag
                @remove="removeTag(tag)"
                :title="tag"
                :disabled="disabled"
              >
                {{ getTagText(tag) }}
              </b-form-tag>
            </li>
          </ul>

          <b-form-select
            v-bind="inputAttrs"
            v-on="inputHandlers"
            :disabled="answerList.length === 0"
            :options="selectOptions"
          >
            <template #first>
              <!-- This is required to prevent bugs with Safari -->
              <option disabled value="">Choose a tag...</option>
            </template>
          </b-form-select>
        </template>
      </b-form-tags>
    </b-form-group>
  </div>
</template>

<script>
export default {
  name: "AccountMultiple",
  props: {
    body: {
      type: Object,
      default() {
        return {};
      },
    },
    question: {
      type: String,
      default: "",
    },
    answerList: {
      type: Array,
      default() {
        return [];
      },
    },
    preAnswer: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      answer: [],
    };
  },
  mounted() {
    this.answer = [];
    let nextQuestion = this.body.next;
    if (this.preAnswer) {
      for (let answer of this.preAnswer.split(", ")) {
        let newAnswer = this.answerList.find((o) => o.name == answer);
        this.answer.push(newAnswer.id);
        if (newAnswer.next) {
          nextQuestion = newAnswer.next;
        }
      }
    }
    this.$emit("load-next", nextQuestion);
  },
  computed: {
    selectOptions() {
      let selectOptions = [];
      for (let answer of this.answerList) {
        selectOptions.push({ value: answer.id, text: answer.name });
      }
      return selectOptions;
    },
  },
  methods: {
    getTagText(tag) {
      return this.selectOptions.find((o) => o.value === tag).text;
    },
    handleAnswerChange() {
      for (let answer of this.answer) {
        let answerCheck = this.answerList.find(
          (o) => o.id == answer && o.hasOwnProperty("next")
        );
        if (answerCheck) {
          this.$emit("load-next", answerCheck.next, this.body.id);
          return;
        }
      }
      this.$emit("load-next", this.body.next, this.body.id);
    },
  },
};
</script>

<style></style>
